import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { HubHealth } from '../types/hubhealth';

@Component({
  selector: 'hub-health',
  templateUrl: './hubhealth.component.html',
  styleUrls: ['./hubhealth.component.css'],
  providers: [HubService],
})


export class HubHealthComponent implements OnInit {
  hubhealth: HubHealth[];
  private workColumnsElement: HTMLCollectionOf<Element>;
  private controlsColumnsElement: HTMLCollectionOf<Element>;
  private environmentColumnsElement: HTMLCollectionOf<Element>;
  workVisible = true;
  controlsVisible = false;
  environmentVisible = false;
  private lastColumnSetClicked = 'W';
  private fromTimestamps: string[];
  errorMessage: string;

  static handleRefreshError(err: any): void {
    if (err.status !== 401) {
      console.log('HubHealth Error: ' + err);
    }
  }

  constructor(
    private hubService: HubService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    if (window.innerWidth >= 800) {
      this.workVisible = true;
      this.controlsVisible = true;
      this.environmentVisible = true;
      console.log('Looks like a desktop/laptop: innerWidth=' + window.innerWidth + ', screen.width=' + screen.width);
    } else {
      console.log('Probably a phone: innerWidth=' + window.innerWidth + ', screen.width=' + screen.width);
    }
    this.later();
  }

  displayedColumnSet(which: string) {
    this.lastColumnSetClicked = which;
    console.log('Displaying columns: ' + which);
    try {
      this.workVisible = (which === 'W');
      this.controlsVisible = (which === 'C');
      this.environmentVisible = (which === 'E');
      for (let i = 0; i < this.workColumnsElement.length; i++) {
        this.workColumnsElement[i]['style'].display = (which === 'W' ? 'inline-block' : 'none');
      }
      for (let i = 0; i < this.controlsColumnsElement.length; i++) {
        this.controlsColumnsElement[i]['style'].display = (which === 'C' ? 'inline-block' : 'none');
      }
      for (let i = 0; i < this.environmentColumnsElement.length; i++) {
        this.environmentColumnsElement[i]['style'].display = (which === 'E' ? 'inline-block' : 'none');
      }
    } catch (err) {}
  }

  getColorFor(hub: HubHealth): string {
    if (hub.gap > 1000 || hub.avg_wake_secs > 80 || hub.uptime < 200 || (hub.voltage && hub.voltage < 3700)) { return '#F4B8B8'; }
    if (hub.gap > 900 || hub.avg_wake_secs > 70 || hub.uptime <  400 || (hub.voltage && hub.voltage < 3750)) { return '#F3C8C0'; }
    if (hub.gap > 800 || hub.avg_wake_secs > 60 || hub.uptime <  800 || (hub.voltage && hub.voltage < 3800)) { return '#F2D8C8'; }
    if (hub.gap > 700 || hub.avg_wake_secs > 50 || hub.uptime < 1600 || (hub.voltage && hub.voltage < 3850)) { return '#F1E8D0'; }
    if (hub.gap > 600 || hub.avg_wake_secs > 40 || hub.uptime < 3200 || (hub.voltage && hub.voltage < 3900)) { return '#F0ECD8'; }
    if (hub.gap > 500 || hub.avg_wake_secs > 30 || hub.uptime < 6400 || (hub.voltage && hub.voltage < 3950)) { return '#EFEEE0'; }
    if (hub.gap > 400 || hub.avg_wake_secs > 20 || hub.uptime < 25600) { return '#EEEEE8'; }
    if (this.errorMessage) { return '#ff8080'; } // So editor doesn't make me think this can be static
    return '#EEEEEE';
  }

  newHealthData(newHealth: HubHealth[]): void {
    this.hubhealth = newHealth;
    this.workColumnsElement = document.getElementsByClassName('working');
    this.controlsColumnsElement = document.getElementsByClassName('controls');
    this.environmentColumnsElement = document.getElementsByClassName('environment');
    if (window.innerWidth < 800) {
      this.displayedColumnSet(this.lastColumnSetClicked);
    }
  }

  earlier(): void {
    let created: string = null;
    try {
      created = this.hubhealth[this.hubhealth.length - 1].created;
      if (!this.fromTimestamps) {
        this.fromTimestamps = [];
      }
      this.fromTimestamps.push(this.hubhealth[0].created)
    } catch (err) {
      console.log(err);
    }
    this.route.params.pipe(
      switchMap((params: Params) => this.hubService.getHealth(+params['hubid'], created, null))
    ).subscribe(hubhealth => this.newHealthData(hubhealth), err => HubHealthComponent.handleRefreshError(err));
  }

  later(): void {
    let created: string = null;
    try {
      created = this.fromTimestamps[this.fromTimestamps.length - 1];
      this.fromTimestamps = this.fromTimestamps.slice(0, -1);
    } catch (err) {}
    this.route.params.pipe(
      switchMap((params: Params) => this.hubService.getHealth(+params['hubid'], created, null))
    ).subscribe(hubhealth => this.newHealthData(hubhealth), err => HubHealthComponent.handleRefreshError(err));
  }
}

